import { PRODUCT_SALE_TYPE, TICKET_TYPE_STRING } from "@src/components/deungi/common/enum";
import React, { useState } from "react";
import { getDeviceType, transferToNative } from "@src/lib/WebAppBridge";

import LocalTicket from "./ui/icon/LocalTicket.png";
import SaleTicket from "./ui/icon/SaleTicket.png";
import SaleTicketX10 from "./ui/icon/SaleTicketX10.png";
import { TicketPackageListResponseDto } from "@src/hooks/deungi/dto/PackageList.dto";
import ico_arrow_back from "@src/assets/ico_arrow_back.png";
import styled from "styled-components";
import { useQueryTicketPackageListByType } from "@src/hooks/deungi/useTicketPackageList";
import { useSearchParams } from "react-router-dom";
import { useGetTicketCount } from "./service/ad.api";

const getTicketIcon = (type: string, quantity: number) => {
    if (type === TICKET_TYPE_STRING.LOCAL_ADS_TICKET) return LocalTicket;
    return quantity >= 10 ? SaleTicketX10 : SaleTicket;
};

const formatPrice = (price: number) => price.toLocaleString();

const AdvertisementPayment = () => {
    const [searchParams] = useSearchParams();
    const disableTicket = searchParams.get("disableTicket");
    const deviceType = getDeviceType();

    const [selectedPackage, setSelectedPackage] = useState<TicketPackageListResponseDto | null>(null);
    const [isGuideOpen, setIsGuideOpen] = useState(false);

    const { data: packageList } = useQueryTicketPackageListByType(
        deviceType === "ios" ? PRODUCT_SALE_TYPE.IOS : PRODUCT_SALE_TYPE.AOS,
    );
    const { data: ticketCount } = useGetTicketCount();

    const localPackages =
        packageList?.list?.filter((el: TicketPackageListResponseDto) => el.type === TICKET_TYPE_STRING.LOCAL_ADS_TICKET) ?? [];
    const salePackages =
        packageList?.list?.filter((el: TicketPackageListResponseDto) => el.type === TICKET_TYPE_STRING.SALE_ADS_TICKET) ?? [];

    const selectedLocalCount = selectedPackage?.type === TICKET_TYPE_STRING.LOCAL_ADS_TICKET ? selectedPackage.quantity : 0;
    const selectedSaleCount = selectedPackage?.type === TICKET_TYPE_STRING.SALE_ADS_TICKET ? selectedPackage.quantity : 0;

    const handleBack = () => {
        transferToNative("done", "closeWebView");
    };

    const handleClickNext = () => {
        if (!selectedPackage) return;
        if (deviceType === "android") {
            const params = JSON.stringify({
                pgType: "kcp.IP29N",
                product_name: selectedPackage.name,
                product_code: selectedPackage.code,
                amount: selectedPackage.discountPrice,
                discounted_price: selectedPackage.discountPrice,
                type: selectedPackage.type,
            });
            transferToNative(params, "payDeungiTicketInApp");
        } else {
            const ticketType = ["", ...Object.values(TICKET_TYPE_STRING)];
            const params = JSON.stringify({
                productCode: selectedPackage.code,
                productType: selectedPackage.type,
                ticketType: ticketType.indexOf(selectedPackage.type),
            });
            transferToNative(params, "payTicketInApp");
        }
    };

    return (
        <Layout>
            <Header>
                <div className="prevBtn" onClick={handleBack}>
                    <img src={ico_arrow_back} alt="뒤로가기" />
                </div>
                <div className="content">
                    <span>충전하기</span>
                </div>
            </Header>

            <Content>
                <TicketCounter>
                    <CounterChip>
                        <div className="icon">
                            <img src={LocalTicket} alt="지역광고권" />
                        </div>
                        <div className="titleBox">
                            <span className="label">지역광고권</span>
                            <span className="count">{ticketCount?.regionAdsTicket}장</span>
                        </div>
                    </CounterChip>

                    <CounterChip>
                        <div className="icon">
                            <img src={SaleTicket} alt="매물광고권" />
                        </div>
                        <div className="titleBox">
                            <span className="label">매물광고권</span>
                            <span className="count">{ticketCount?.itemAdsTicket}장</span>
                        </div>
                    </CounterChip>
                </TicketCounter>

                <Divider />

                {disableTicket !== "local" && (
                    <Section>
                        <SectionTitle>지역광고권</SectionTitle>
                        {localPackages.map((item: TicketPackageListResponseDto) => (
                            <TicketCard
                                key={item.code}
                                $selected={selectedPackage?.code === item.code}
                                onClick={() => setSelectedPackage(item)}
                            >
                                <div className="cardLeft">
                                    <ImageBox>
                                        <img src={getTicketIcon(item.type, item.quantity)} alt={item.name} />
                                    </ImageBox>
                                    <div className="ticketInfo">
                                        <span className="ticketName">{item.name}</span>
                                        {item.discountString && <PromotionBadge>{item.discountString}</PromotionBadge>}
                                    </div>
                                </div>
                                <div className="cardRight">
                                    <span className="price">{formatPrice(item.discountPrice)}원</span>
                                </div>
                            </TicketCard>
                        ))}
                    </Section>
                )}

                {disableTicket !== "sale" && (
                    <Section>
                        <SectionTitle>매물광고권</SectionTitle>
                        {salePackages.map((item: TicketPackageListResponseDto) => (
                            <TicketCard
                                key={item.code}
                                $selected={selectedPackage?.code === item.code}
                                onClick={() => setSelectedPackage(item)}
                            >
                                <div className="cardLeft">
                                    <ImageBox>
                                        <img src={getTicketIcon(item.type, item.quantity)} alt={item.name} />
                                    </ImageBox>
                                    <div className="ticketInfo">
                                        <span className="ticketName">{item.name}</span>
                                        {item.discountString && <PromotionBadge>{item.discountString}</PromotionBadge>}
                                    </div>
                                </div>
                                <div className="cardRight">
                                    <span className="price">{formatPrice(item.discountPrice)}원</span>
                                </div>
                            </TicketCard>
                        ))}
                    </Section>
                )}

                <GuideSection>
                    <GuideHeader onClick={() => setIsGuideOpen((prev) => !prev)}>
                        <span>광고권 충전 이용안내</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M2.20031 6.33662C1.93323 6.07517 1.93323 5.64527 2.20031 5.38382L2.39803 5.19027C2.65719 4.93658 3.07159 4.93658 3.33075 5.19027L7.71365 9.48078L12.0966 5.19027C12.3557 4.93658 12.7701 4.93658 13.0293 5.19027L13.227 5.38382C13.4941 5.64527 13.4941 6.07517 13.227 6.33662L8.18001 11.2772C7.92086 11.5309 7.50645 11.5309 7.24729 11.2772L2.20031 6.33662Z"
                                fill="#0C002C"
                                stroke="#0C002C"
                                strokeWidth="0.5"
                            />
                        </svg>
                    </GuideHeader>
                    {isGuideOpen && (
                        <GuideContent>
                            - 매물광고권은 사용하지 않은 경우에 한 해, 구매 후 7일 이내에 자주묻는질문에서 직접 구매 취소할 수
                            있습니다.
                            <br />- 구매 후 7일 이내임에도 {"'내정보>고객센터>자주묻는질문>매물광고권 취소/환불하기'"}에{" "}
                            {"'취소 불가'"} 상태라면 다음 중 하나 이상의 경우에 해당합니다.
                            <br />
                            1) 광고권 패키지의 일부를 사용하여서 직접 환불이 불가능한 경우
                            <br />
                            2) Google Play 결제를 통해 구매한 경우
                            <br />
                            3) iOS APP Store 결제를 통해 구매한 경우
                            <br />- 위 경우에 해당하는 결제 건의 구매 취소를 희망할 경우, 열람권 유효 기간 내에 고객센터로 문의해
                            주세요.
                            <br />- 단, iOS APP Store 결제로 구매한 광고권의 구매 취소는 APPLE 고객센터를 통해서만 가능합니다.
                            <br />- Google Play 결제로 구매한 광고권은 구매 후 48시간 이내에는 Google Play 고객센터를 통해, 48시간
                            이후에는 고객센터를 통해 구매 취소할 수 있습니다.
                            <br />- 구매 취소나 환불 시에는 결제한 수단으로 환불됩니다.
                            <br />- 구독 혜택 등 무료로 지급된 광고권은 환불 대상에서 제외됩니다.
                        </GuideContent>
                    )}
                </GuideSection>
            </Content>

            <BottomArea>
                <NextButton onClick={handleClickNext} $active={selectedPackage !== null} disabled={selectedPackage === null}>
                    다음
                </NextButton>
            </BottomArea>
        </Layout>
    );
};

export default AdvertisementPayment;

const Layout = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
    height: calc(var(--vh, 1vh) * 100);
    background: #ffffff;
`;

const Header = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    width: 100%;
    min-height: 56px;
    height: 56px;
    padding: 14px;

    .prevBtn {
        position: absolute;
        left: 5px;
        top: 10px;
        width: 40px;
        height: 40px;
        padding: 10px;
        cursor: pointer;

        & > img {
            width: 10px;
            height: 17px;
        }
    }

    .content {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-weight: 700;
        line-height: 28px;
        color: #0c002c;
    }
`;

const Content = styled.div`
    flex: 1;
    overflow-y: auto;
    padding: 0 14px;
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
        display: none;
    }
`;

const TicketCounter = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 8px;
    padding: 12px 0;
`;

const CounterChip = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 8px;
    border-radius: 8px;
    background: #f6faff;

    .icon {
        width: 38px;
        height: 38px;
        padding: 4px;

        border-radius: 4px;
        background-color: #fff;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .titleBox {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0 20px;
    }

    .label {
        color: #0c002c;
        text-align: center;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
    }

    .count {
        color: #0047ff;
        text-align: center;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 24px;
    }
`;

const Divider = styled.div`
    width: 100%;
    height: 1px;
    background: #e3e3e6;
    margin: 4px 0;
`;

const Section = styled.div`
    margin-top: 20px;
`;

const SectionTitle = styled.div`
    font-size: 16px;
    font-weight: 600;
    line-height: 140%;
    letter-spacing: -0.4px;
    color: #0c002c;
    margin-bottom: 10px;
`;

const TicketCard = styled.div<{ $selected: boolean }>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 14px;
    border-radius: 12px;
    border: 1.5px solid ${({ $selected }) => ($selected ? "#2275EE" : "#D4D4D8")};
    margin-bottom: 8px;
    cursor: pointer;
    transition: all 0.15s ease;

    .cardLeft {
        display: flex;
        align-items: center;
        gap: 12px;
    }

    .ticketInfo {
        display: flex;
        flex-direction: column;
    }

    .ticketName {
        color: #0c002c;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
    }

    .cardRight {
        display: flex;
        align-items: center;
    }

    .price {
        color: #0c002c;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 26px;
    }
`;

const ImageBox = styled.div`
    position: relative;
    min-width: 50px;
    height: 50px;
    border-radius: 8px;
    background-color: #f6faff;

    & > img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 38px;
        height: 38px;
    }
`;

const PromotionBadge = styled.span`
    color: #f00;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
`;

const GuideSection = styled.div`
    margin-top: 24px;
    margin-bottom: 20px;
    border-radius: 12px;
    background: #f4f5f7;
    overflow: hidden;
`;

const GuideHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14px 16px;
    cursor: pointer;

    & > span {
        font-size: 14px;
        font-weight: 500;
        line-height: 140%;
        color: #818181;
    }
`;

const GuideContent = styled.div`
    padding: 0 16px 14px;
    font-size: 11px;
    font-weight: 400;
    line-height: 20px;
    color: #a3a3a3;
`;

const BottomArea = styled.div`
    padding: 10px 14px;
    padding-bottom: calc(10px + env(safe-area-inset-bottom));
    background: #ffffff;
`;

const NextButton = styled.button<{ $active: boolean }>`
    width: 100%;
    height: 52px;
    border-radius: 12px;
    border: none;
    background: ${({ $active }) => ($active ? "#2275EE" : "#D4D4D8")};
    cursor: ${({ $active }) => ($active ? "pointer" : "default")};
    transition: all 0.15s ease;

    color: #ffffff;
    text-align: center;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
`;
